<template>
  <div class="bg-card p-5 rounded-lg shadow-sm h-full">
    <div class="wrapper">
      <Skeleton class="skeleton__item rounded-md" />
      <Skeleton class="skeleton__item rounded-md" />
      <Skeleton class="skeleton__item rounded-md" />

      <div class="spacer"></div>

      <Skeleton class="skeleton__item rounded-md" />
      <Skeleton class="skeleton__item last rounded-md" />
    </div>
  </div>
</template>

<script setup>
import { Skeleton } from "@/shared/ui/skeleton";
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.spacer {
  flex-grow: 1;
}

.skeleton__item {
  width: 120px;
  height: 25px;
  margin-right: 5px;
}

.skeleton__item.last {
  margin-right: 0;
  width: 100px;
}
</style>
